import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';
import { BulkInvalidPartAttributesResponse } from '../../../types/analyses';

export type BulkAIQuickFixesState = {
  readonly fetchInvalidPartAttributes: boolean;
  readonly invalidPartAttributesData: BulkInvalidPartAttributesResponse | null;
  readonly fetchInvalidPartAttributeValues: boolean;
  readonly invalidPartAttributeValuesData: BulkInvalidPartAttributesResponse | null;
  readonly acceptingQuickFixes: number[];
};

const initialState: BulkAIQuickFixesState = {
  fetchInvalidPartAttributes: false,
  invalidPartAttributesData: null,
  fetchInvalidPartAttributeValues: false,
  invalidPartAttributeValuesData: null,
  acceptingQuickFixes: [],
};

const reducer: Reducer<BulkAIQuickFixesState, FluxStandardAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FETCH_INVALID_PART_ATTRIBUTES_PENDING': {
      return {
        ...state,
        fetchInvalidPartAttributes: true,
      };
    }
    case 'FETCH_INVALID_PART_ATTRIBUTES_FULFILLED': {
      return {
        ...state,
        fetchInvalidPartAttributes: false,
        invalidPartAttributesData: action.payload.data,
      };
    }
    case 'FETCH_INVALID_PART_ATTRIBUTES_REJECTED': {
      return {
        ...state,
        fetchInvalidPartAttributes: false,
        invalidPartAttributesData: null,
      };
    }
    case 'FETCH_INVALID_PART_ATTRIBUTE_VALUES_PENDING': {
      return {
        ...state,
        fetchInvalidPartAttributeValues: true,
      };
    }
    case 'FETCH_INVALID_PART_ATTRIBUTE_VALUES_FULFILLED': {
      return {
        ...state,
        fetchInvalidPartAttributeValues: false,
        invalidPartAttributeValuesData: action.payload.data,
      };
    }
    case 'FETCH_INVALID_PART_ATTRIBUTE_VALUES_REJECTED': {
      return {
        ...state,
        fetchInvalidPartAttributeValues: false,
        invalidPartAttributeValuesData: null,
      };
    }
    case 'ACCEPT_AI_QUICK_FIX_PENDING': {
      const { quickFix } = action.meta;
      return {
        ...state,
        acceptingQuickFixes: [...state.acceptingQuickFixes, quickFix.reference_id],
      };
    }
    case 'ACCEPT_AI_QUICK_FIX_FULFILLED': {
      const { quickFix } = action.meta;
      return {
        ...state,
        acceptingQuickFixes: state.acceptingQuickFixes.filter(id => id !== quickFix.reference_id),
      };
    }
    case 'ACCEPT_AI_QUICK_FIX_REJECTED': {
      const { quickFix } = action.meta;
      return {
        ...state,
        acceptingQuickFixes: state.acceptingQuickFixes.filter(id => id !== quickFix.reference_id),
      };
    }
  }
  return state;
};

export default reducer;
